import { useCallback } from "react";
import { create } from "zustand";
import { useLocation } from "react-router-dom";

const useLoadingStore = create((set) => ({
  loadingStates: {},
  setIsLoading: (key, loading) =>
    set((state) => ({
      loadingStates: {
        ...state.loadingStates,
        [key]: loading,
      },
    })),
}));

export function usePageLoading() {
  const location = useLocation();
  const path = location.pathname;

  const isLoading = useLoadingStore((state) => state.loadingStates[path] || false);
  const setIsLoadingGlobal = useLoadingStore((state) => state.setIsLoading);

  const setIsLoading = useCallback((loading) => {
    setIsLoadingGlobal(path, loading);
  }, [setIsLoadingGlobal, path]);

  return [isLoading, setIsLoading];
}

export default useLoadingStore;
